export {
  Page,
  Card,
  Title,
  Form,
  FieldGroup,
  Label,
  Input,
  SubmitButton,
  ErrorMessage,
  SuccessMessage,
  CodeInputRow,
  CodeCharInput,
  LinkButton,
  Subtitle,
} from './LoginPage.styled';

import styled from 'styled-components';

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 0.9375rem;
  text-align: center;
  margin: -16px 0 8px;
  line-height: 1.5;
`;

export const StatusText = styled.p`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 0.9375rem;
  text-align: center;
  margin: 16px 0;
`;
